class ContentEditable {
	public restrict: string = 'A';
	public scope: boolean = true;
	public require = 'ngModel';
	
	constructor(
		private $sce : ng.ISCEService	
	) {}

	public static Factory() {
		var directive:any = ( $sce ) => new this( $sce );
        directive.$inject = ['$sce'];
        return directive;
	}
	
	public link = (scope, element, attrs, ngModel) => {
		
		// Specify how UI should be updated
		ngModel.$render = function() {
			element.html( this.$sce.getTrustedHtml( ngModel.$viewValue || '' ) );
			read(); // initialize
		}
		
		element.on('blur keyup change', function() {
			scope.$evalAsync( read );
		});
		
		function read() {
			var text = element.html();
			// Strip tags.
			text.replace(/(<([^>]+)>)/ig,"");
			ngModel.$setViewValue( text );
		}
    }
}

export { ContentEditable };
